import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

export const Layout = () => {
  const navigate = useNavigate();
  const openContact = () => navigate("/contact");

  return (
    <div style={{ position: "relative", overflowX: "hidden" }} data-testid="macaron-app">
      <ScrollToTop />
      <div className="orb orb-pink" />
      <div className="orb orb-cyan" />

      <Navbar onContact={openContact} />
      <Outlet context={{ openContact }} />
      <Footer />
    </div>
  );
};
